// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"722":"655f591a","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};